export const makeFileUrlByFileId = (fileId: string) => {
    return `https://docs.google.com/spreadsheets/d/${fileId}/edit?usp=drivesdk`
}
